import styles from "./TemplatesHomepages.module.css";
import { Icon, IconName } from "@zapier/zinnia-icons";
import { Text } from "@zapier/design-system";
import { CrossDomainImage } from "../CrossDomainImage/CrossDomainImage";
import { components } from "@zapier/api-clients/apis/templates-backend";
import { useTranslations } from "next-intl";

export const ProductsSection = ({
  products,
}: {
  products: components["schemas"]["Product"][];
}) => {
  const t = useTranslations("Sections");

  return (
    <section className={styles.productsSection}>
      <div className={styles.productsContainer}>
        <Text
          type="PageHeader"
          tag="h2"
          margin="0 0 16px 0"
          className={styles.sectionHeader}
          color="TextDefault"
        >
          {t("browseByProduct")}
        </Text>
        <div className={styles.products}>
          {products.map(
            (product) =>
              product.image?.url && (
                <a
                  href={`/templates/${product.slug}`}
                  key={product.slug}
                  className={styles.productCard}
                >
                  <div className={styles.productNameContainer}>
                    <Icon
                      name={product.iconName as IconName}
                      color="BrandOrange"
                      isBlock={true}
                    />
                    <Text
                      type="ParagraphHeader3"
                      className={styles.productName}
                    >
                      {product.name}
                    </Text>
                  </div>
                  <CrossDomainImage
                    src={product.image.url}
                    alt=""
                    className={styles.productImage}
                    width="418"
                    height="264"
                  />
                </a>
              ),
          )}
        </div>
      </div>
    </section>
  );
};
